export default {
  'pages.login.success': 'Connexion réussie !',
  'pages.login.failure': 'Échec de la connexion, veuillez réessayer !',
  'pages.login.username.placeholder': "Nom d'utilisateur",
  'pages.login.username.required': "Veuillez saisir votre nom d'utilisateur !",
  'pages.login.password.placeholder': 'Mot de passe',
  'pages.login.password.required': 'Veuillez saisir votre mot de passe !',
  'pages.login.rememberMe': 'Se souvenir de moi',
  'pages.login.forgotPassword': 'Mot de passe oublié ?',
  'pages.login.forgotPasswordInfo':
    "Veuillez contacter l'administrateur pour réinitialiser le mot de passe",
  'pages.login.submit': 'Se connecter',
  'pages.login.back': 'Retour',
  'pages.login.emailCheck.title': 'Vérification par e-mail',
  'pages.login.emailCheck.description':
    'Un code à 6 chiffres a été envoyé à {email}',
  'pages.login.emailCheck.sent':
    'Un code de vérification a été envoyé sur votre adresse e-mail',
  'pages.login.tfaCheck.title': 'Authentification à deux facteurs',
  'pages.login.tfaCheck.description':
    "Saisissez le code à 6 chiffres de votre application d'authentification",
  'pages.login.verifyCode.submit': 'Vérifier',
  'pages.login.verifyCode.invalid': 'Code de vérification invalide',
  'pages.login.oidc.divider': 'Ou continuer avec',
  'pages.login.oidc.continueWith': 'Continuer avec {provider}',
  'pages.login.oidc.authFailed': 'Échec de la connexion OIDC',
  'pages.login.passkey.login': 'Se connecter avec une Passkey',
  'pages.login.passkey.verify': 'Vérifier avec une Passkey',
  'pages.login.passkey.cancelled':
    'La vérification de la Passkey a été annulée',
  'pages.login.passkey.failed': 'La vérification de la Passkey a échoué',
  'pages.login.passkeyCheck.title': 'Vérification par Passkey',
  'pages.login.passkeyCheck.description':
    'Utilisez votre Passkey pour finaliser la connexion',
  'pages.devices.list': 'Liste des appareils',
  'pages.devices.os': "Système d'exploitation",
  'pages.devices.status': 'Statut',
  'pages.devices.user': 'Utilisateur',
  'pages.devices.deviceGroup': 'Groupe',
  'pages.devices.note': 'Note',
  'pages.devices.online': 'En ligne',
  'pages.devices.offline': 'Hors ligne',
  'pages.devices.days': 'jours',
  'pages.devices.hours': 'heures',
  'pages.devices.minutes': 'minutes',
  'pages.devices.justNow': "à l'instant",
  'pages.devices.enable': 'Activer',
  'pages.devices.disable': 'Désactiver',
  'pages.devices.enableSuccess': 'Appareil activé',
  'pages.devices.enableFailed': "Échec de l'activation de l'appareil",
  'pages.devices.disableSuccess': 'Appareil désactivé',
  'pages.devices.disableFailed': "Échec de la désactivation de l'appareil",
  'pages.devices.deleteSuccess': 'Appareil supprimé',
  'pages.devices.deleteFailed': "Échec de la suppression de l'appareil",
  'pages.devices.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cet appareil ?',
  'pages.devices.deviceInfo': 'nom_utilisateur@nom_appareil',
  'pages.devices.strategyInfo': 'Informations sur la stratégie',
  'pages.devices.device': 'Appareil',
  'pages.devices.strategy': 'Stratégie',
  'pages.devices.info': 'Infos',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Désactivé',
  'pages.devices.onlineStatus': 'Statut en ligne',
  'pages.devices.deviceGroupSearchTip': "Filtrer par nom de groupe d'appareils",
  'pages.devices.remove': 'Retirer',
  'pages.devices.removeFromGroupSuccess': 'Appareil retiré du groupe',
  'pages.devices.removeFromGroupFailed':
    "Échec du retrait de l'appareil du groupe",
  'pages.devices.removeFromGroupConfirm':
    'Êtes-vous sûr de vouloir retirer cet appareil du groupe ?',
  'pages.devices.batchRemove': 'Retirer en lot',
  'pages.devices.batchRemoveFromGroupSuccess':
    '{count} appareil(s) retiré(s) du groupe avec succès',
  'pages.devices.batchRemoveFromGroupFailed':
    'Échec du retrait des appareils du groupe',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Êtes-vous sûr de vouloir retirer les appareils sélectionnés du groupe ?',
  'pages.devices.batchEnable': 'Activer en lot',
  'pages.devices.batchDisable': 'Désactiver en lot',
  'pages.devices.batchEnableConfirm':
    'Êtes-vous sûr de vouloir activer les appareils sélectionnés ?',
  'pages.devices.batchDisableConfirm':
    'Êtes-vous sûr de vouloir désactiver les appareils sélectionnés ?',
  'pages.devices.batchEnableSuccess':
    '{count} appareil(s) activé(s) avec succès',
  'pages.devices.batchEnableFailed': "Échec de l'activation des appareils",
  'pages.devices.batchEnablePartialFailed':
    '{success} appareil(s) activé(s) avec succès, {failed} échec(s)',
  'pages.devices.batchDisableSuccess':
    '{count} appareil(s) désactivé(s) avec succès',
  'pages.devices.batchDisableFailed': 'Échec de la désactivation des appareils',
  'pages.devices.batchDisablePartialFailed':
    '{success} appareil(s) désactivé(s) avec succès, {failed} échec(s)',
  'pages.devices.edit': "Modifier l'appareil",
  'pages.devices.updateSuccess': 'Appareil mis à jour',
  'pages.devices.updateFailed': "Échec de la mise à jour de l'appareil",
  'pages.devices.selectUser': "Sélectionner l'utilisateur",
  'pages.devices.selectDeviceGroup': "Sélectionner le groupe d'appareils",
  'pages.devices.selectStrategy': 'Sélectionner la stratégie',
  'pages.devices.connect': 'Connecter',
  'pages.devices.connectRemoteDesktop': 'Bureau distant',
  'pages.devices.connectFileTransfer': 'Transfert de fichiers',
  'pages.devices.connectViewCamera': 'Voir la caméra',
  'pages.devices.connectPortForward': 'Transfert de port',
  'pages.devices.connectRdp': 'RDP',
  'pages.devices.connectTerminal': 'Terminal',
  'pages.devices.connectTerminalAdmin': 'Terminal (Admin)',
  'pages.devices.searchIdPlaceholder': 'Rechercher par ID de périphérique',
  'pages.devices.searchUserPlaceholder': "Rechercher par nom d'utilisateur",
  'pages.devices.searchOsPlaceholder': 'Rechercher par OS',
  'pages.devices.searchDeviceGroupPlaceholder':
    'Rechercher par nom de groupe de périphériques',
  'pages.addressBook.name': 'Nom',
  'pages.addressBook.note': 'Note',
  'pages.addressBook.shared': "Carnets d'adresses partagés",
  'pages.addressBook.create': "Créer un carnet d'adresses",
  'pages.addressBook.edit': "Modifier le carnet d'adresses",
  'pages.addressBook.personal': "Carnet d'adresses personnel",
  'pages.addressBook.currentAddressBook': "Carnet d'adresses",
  'pages.addressBook.myAddressBook': "Mon carnet d'adresses",
  'pages.addressBook.loadFailed': "Échec du chargement des carnets d'adresses",
  'pages.addressBook.addPeer': 'Ajouter par ID',
  'pages.addressBook.addTag': 'Ajouter une étiquette',
  'pages.addressBook.tagName': "Nom de l'étiquette",
  'pages.addressBook.tagAdded': 'Étiquette ajoutée',
  'pages.addressBook.tagAddFailed': "Échec de l'ajout de l'étiquette",
  'pages.addressBook.tagDeleted': 'Étiquette supprimée',
  'pages.addressBook.tagDeleteFailed': "Échec de la suppression de l'étiquette",
  'pages.addressBook.deleteTagConfirm':
    'Êtes-vous sûr de vouloir supprimer cette étiquette ?',
  'pages.addressBook.tagModeUnion': 'Au moins une',
  'pages.addressBook.tagModeIntersection': 'Toutes',
  'pages.addressBook.importDevices': 'Importer depuis les appareils',
  'pages.addressBook.importSuccess':
    '{count} appareil(s) importé(s) avec succès',
  'pages.addressBook.importPartialFailed':
    "Échec de l'importation de {count} appareil(s)",
  'pages.addressBook.createSuccess': "Carnet d'adresses créé",
  'pages.addressBook.createFailed': "Échec de la création du carnet d'adresses",
  'pages.addressBook.updateSuccess': "Carnet d'adresses mis à jour",
  'pages.addressBook.updateFailed':
    "Échec de la mise à jour du carnet d'adresses",
  'pages.addressBook.deleteSuccess': "Carnet(s) d'adresses supprimé(s)",
  'pages.addressBook.deleteFailed':
    "Échec de la suppression du ou des carnets d'adresses",
  'pages.addressBook.deleteConfirm':
    "Êtes-vous sûr de vouloir supprimer ce carnet d'adresses ?",
  'pages.addressBook.batchDeleteConfirm':
    "Êtes-vous sûr de vouloir supprimer les carnets d'adresses sélectionnés ?",
  'pages.addressBook.device': 'Appareil',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Étiquettes',
  'pages.addressBook.peerAdded': 'Pair ajouté',
  'pages.addressBook.peerAddFailed': "Échec de l'ajout du pair",
  'pages.addressBook.peerDeleted': 'Pair supprimé',
  'pages.addressBook.peerDeleteFailed': 'Échec de la suppression du pair',
  'pages.addressBook.deletePeerConfirm':
    'Êtes-vous sûr de vouloir supprimer ce pair ?',
  'pages.addressBook.import': 'Importer depuis les appareils',
  'pages.deviceGroups.list': "Groupes d'appareils",
  'pages.deviceGroups.name': 'Nom',
  'pages.deviceGroups.note': 'Note',
  'pages.deviceGroups.create': "Créer un groupe d'appareils",
  'pages.deviceGroups.edit': "Modifier le groupe d'appareils",
  'pages.deviceGroups.createSuccess': "Groupe d'appareils créé",
  'pages.deviceGroups.createFailed':
    "Échec de la création du groupe d'appareils",
  'pages.deviceGroups.updateSuccess': "Groupe d'appareils mis à jour",
  'pages.deviceGroups.updateFailed':
    "Échec de la mise à jour du groupe d'appareils",
  'pages.deviceGroups.deleteSuccess': "Groupe d'appareils supprimé",
  'pages.deviceGroups.deleteFailed':
    "Échec de la suppression du groupe d'appareils",
  'pages.deviceGroups.deleteConfirm':
    "Êtes-vous sûr de vouloir supprimer ce groupe d'appareils ?",
  'pages.deviceGroups.import': 'Importer',
  'pages.deviceGroups.importDevices': 'Importer des appareils',
  'pages.deviceGroups.importSuccess':
    '{count} appareil(s) importé(s) avec succès',
  'pages.deviceGroups.importFailed': "Échec de l'importation des appareils",
  'pages.deviceGroups.searchNamePlaceholder': 'Rechercher par nom',
  'pages.users.list': 'Liste des utilisateurs',
  'pages.users.name': 'Nom',
  'pages.users.displayName': "Nom d'affichage",
  'pages.users.email': 'E-mail',
  'pages.users.note': 'Note',
  'pages.users.status': 'Statut',
  'pages.users.create': 'Créer un utilisateur',
  'pages.users.createSuccess': 'Utilisateur créé',
  'pages.users.createFailed': "Échec de la création de l'utilisateur",
  'pages.users.deleteSuccess': 'Utilisateur supprimé',
  'pages.users.deleteFailed': "Échec de la suppression de l'utilisateur",
  'pages.users.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
  'pages.audits.conn': 'Audits de connexion',
  'pages.audits.file': 'Journaux de transfert de fichiers',
  'pages.audits.alarm': "Audits d'alarmes",
  'pages.audits.console': 'Audits de console',
  'pages.audits.requestedAt': 'Demandé le',
  'pages.audits.establishedAt': 'Établi le',
  'pages.audits.closedAt': 'Fermé le',
  'pages.audits.action': 'Action',
  'pages.audits.time': 'Heure',
  'pages.audits.alarmType': "Type d'alarme",
  'pages.audits.user': 'Utilisateur',
  'pages.audits.detail': 'Détail',
  'pages.audits.type': 'Type',
  'pages.audits.connType.remoteDesktop': 'Bureau à distance',
  'pages.audits.connType.fileTransfer': 'Transfert de fichiers',
  'pages.audits.connType.portTransfer': 'Redirection de port',
  'pages.audits.connType.viewCamera': 'Voir la caméra',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Non connecté',
  'pages.audits.duration': 'Durée',
  'pages.audits.note': 'Note',
  'pages.audits.disconnect': 'Déconnecter',
  'pages.audits.disconnectSuccess': 'Déconnexion réussie !',
  'pages.audits.disconnectFailed': 'La déconnexion a échoué !',
  'pages.audits.disconnectConfirmTitle': "Confirmer l'opération",
  'pages.audits.disconnectConfirmTip':
    'Êtes-vous sûr de vouloir déconnecter cet appareil ?',
  'pages.audits.updateSuccess': 'Mise à jour réussie',
  'pages.audits.updateFailed': 'La mise à jour a échoué, veuillez réessayer !',
  'pages.audits.exportCSV': 'Exporter en CSV',
  'pages.audits.noDataToExport': 'Aucune donnée à exporter',
  'pages.audits.exportSuccess': 'Exportation réussie',
  'pages.audits.exportFailed': "L'exportation a échoué",
  'pages.audits.exportConfirmTitle': 'Exporter en CSV',
  'pages.audits.exportConfirmContent':
    "Exporter jusqu'à 1 000 enregistrements. Continuer ?",
  'pages.audits.remote': 'Distant',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direction',
  'pages.audits.files': 'Fichiers',
  'pages.audits.remoteTip': 'Ordinateur ou terminal contrôlé à distance',
  'pages.audits.remoteSearchTip':
    "Recherche par ID d'appareil distant (recherche floue)",
  'pages.audits.remotePlaceholder': "Entrez l'ID de l'appareil distant",
  'pages.audits.pathTip': "Chemin d'accès de l'appareil distant",
  'pages.audits.exportCsvTip':
    "Exporter jusqu'à 1 000 enregistrements à la fois",
  'pages.audits.limitedTip': 'Afficher les 10 plus grands fichiers par taille',
  'pages.audits.startTime': 'Heure de début',
  'pages.audits.endTime': 'Heure de fin',
  'pages.audits.alarmType.ipWhitelist': 'IP non présente dans la liste blanche',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'Même IP : plus de 30 tentatives échouées',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'Plus de 6 tentatives en 1 minute',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'Limite de tentatives dépassée pour le préfixe IPv6',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Connexion au terminal OS bloquée par temporisation',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Limite de connexions simultanées au terminal OS dépassée',
  'pages.audits.alarmType.sessionScopeViolation':
    'Violation des permissions de portée de session',
  'pages.audits.alarmType.idWhitelist': 'ID non présent dans la liste blanche',
  'pages.audits.primaryAuth': 'Authentification principale',
  'pages.audits.primaryAuth.none': 'Aucune',
  'pages.audits.primaryAuth.click': 'Clic',
  'pages.audits.primaryAuth.temporaryPassword': 'Mot de passe temporaire',
  'pages.audits.primaryAuth.permanentPassword': 'Mot de passe permanent',
  'pages.audits.primaryAuth.switchSides': 'Inverser les côtés',
  'pages.audits.twoFactor': 'Authentification à deux facteurs',
  'pages.audits.twoFactor.none': 'Aucune',
  'pages.audits.twoFactor.totp': 'TOTP',
  'pages.audits.twoFactor.trustedDevice': 'Appareil de confiance',
  'pages.common.action': 'Action',
  'pages.common.delete': 'Supprimer',
  'pages.common.edit': 'Modifier',
  'pages.common.batchDelete': 'Supprimer en lot',
  'pages.404.subTitle': "Désolé, la page que vous visitez n'existe pas",
  'pages.404.buttonText': "Retour à l'accueil",
  'pages.customClients.createdAt': 'Créé le',
  'pages.userGroups.list': "Liste des groupes d'utilisateurs",
  'pages.userGroups.name': 'Nom du groupe',
  'pages.userGroups.note': 'Note',
  'pages.userGroups.userCount': "Nombre d'utilisateurs",
  'pages.userGroups.create': "Créer un groupe d'utilisateurs",
  'pages.userGroups.edit': "Modifier le groupe d'utilisateurs",
  'pages.userGroups.deleteConfirm':
    "Êtes-vous sûr de vouloir supprimer ce groupe d'utilisateurs ?",
  'pages.userGroups.createSuccess': "Groupe d'utilisateurs créé",
  'pages.userGroups.createFailed':
    "Échec de la création du groupe d'utilisateurs",
  'pages.userGroups.updateSuccess': "Groupe d'utilisateurs mis à jour",
  'pages.userGroups.updateFailed':
    "Échec de la mise à jour du groupe d'utilisateurs",
  'pages.userGroups.deleteSuccess': "Groupe d'utilisateurs supprimé",
  'pages.userGroups.deleteFailed':
    "Échec de la suppression du groupe d'utilisateurs",
  'pages.userGroups.loadFailed':
    "Échec du chargement des groupes d'utilisateurs",
  'pages.userGroups.default': 'Par défaut',
  'pages.userGroups.destination': 'Groupe de destination',
  'pages.userGroups.selectDestination': 'Sélectionner le groupe de destination',
  'pages.userGroups.move': 'Déplacer',
  'pages.userGroups.batchMove': 'Déplacer en lot',
  'pages.userGroups.moveToGroup': 'Déplacer vers le groupe',
  'pages.userGroups.import': 'Importer',
  'pages.userGroups.importUsers': 'Importer des utilisateurs',
  'pages.userGroups.importSuccess':
    '{count} utilisateur(s) importé(s) avec succès',
  'pages.userGroups.importFailed': "Échec de l'importation des utilisateurs",
  'pages.userGroups.membersUpdated': '{count} utilisateur(s) mis à jour',
  'pages.userGroups.membersUpdateFailed':
    'Échec de la mise à jour des membres du groupe',
  'pages.users.userGroup': "Groupe d'utilisateurs",
  'pages.users.selectUserGroup': "Sélectionner un groupe d'utilisateurs",
  'pages.addressBook.userGroup': "Groupe d'utilisateurs",
  'pages.addressBook.permission': 'Autorisation',
  'pages.addressBook.permissionRead': 'Lecture seule',
  'pages.addressBook.permissionReadWrite': 'Lecture et écriture',
  'pages.addressBook.permissionFull': 'Contrôle total',
  'pages.addressBook.shareAccess': 'Partager',
  'pages.addressBook.accessTitle': '{name} - Gestion des accès',
  'pages.addressBook.shareType': 'Type de partage',
  'pages.addressBook.shareTarget': 'Cible',
  'pages.addressBook.shareTypeEveryone': 'Tout le monde',
  'pages.addressBook.shareTypeUser': 'Utilisateur',
  'pages.addressBook.shareTypeGroup': "Groupe d'utilisateurs",
  'pages.addressBook.selectUser': "Sélectionner l'utilisateur",
  'pages.addressBook.selectUserPlaceholder':
    "Rechercher par nom d'utilisateur ou e-mail",
  'pages.addressBook.everyoneHint':
    "Tous les utilisateurs auront accès à ce carnet d'adresses",
  'pages.addressBook.allUsers': 'Tous les utilisateurs',
  'pages.addressBook.addAccess': 'Ajouter un accès',
  'pages.addressBook.accessLoadFailed':
    "Échec du chargement des règles d'accès",
  'pages.addressBook.accessAdded': "Règle d'accès ajoutée",
  'pages.addressBook.accessAddFailed': "Échec de l'ajout de la règle d'accès",
  'pages.addressBook.accessUpdated': "Règle d'accès mise à jour",
  'pages.addressBook.accessUpdateFailed':
    "Échec de la mise à jour de la règle d'accès",
  'pages.addressBook.accessDeleted': "Règle d'accès supprimée",
  'pages.addressBook.accessDeleteFailed':
    "Échec de la suppression de la règle d'accès",
  'pages.addressBook.accessDeleteConfirm': "Supprimer cette règle d'accès ?",
  'pages.roles.list': 'Liste des rôles',
  'pages.roles.name': 'Nom du rôle',
  'pages.roles.note': 'Note',
  'pages.roles.permissions': 'Autorisations',
  'pages.roles.permissionsInfo': "Nombre d'autorisations attribuées",
  'pages.roles.create': 'Créer un rôle',
  'pages.roles.edit': 'Modifier le rôle',
  'pages.roles.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
  'pages.roles.selectPermissions': 'Sélectionner les autorisations',
  'pages.roles.createSuccess': 'Rôle créé avec succès',
  'pages.roles.createFailed': 'Échec de la création du rôle',
  'pages.roles.updateSuccess': 'Rôle mis à jour avec succès',
  'pages.roles.updateFailed': 'Échec de la mise à jour du rôle',
  'pages.roles.deleteSuccess': 'Rôle supprimé avec succès',
  'pages.roles.deleteFailed': 'Échec de la suppression du rôle',
  'pages.settings.save': 'Enregistrer les paramètres',
  'pages.settings.general': 'Paramètres généraux',
  'pages.settings.fetchFailed': 'Échec du chargement des paramètres',
  'pages.settings.saveSuccess': 'Paramètres enregistrés avec succès',
  'pages.settings.saveFailed': "Échec de l'enregistrement des paramètres",
  'pages.settings.generalSection.watermark': "Filigrane du nom d'utilisateur",
  'pages.settings.generalSection.watermarkExtra':
    "Afficher en surimpression le nom de l'utilisateur sur chaque page à des fins de responsabilité.",
  'pages.settings.generalSection.language': 'Langue par défaut',
  'pages.settings.generalSection.languageExtra':
    "Langue d'interface par défaut pour les nouveaux visiteurs. Les utilisateurs connectés conservent leur propre préférence.",
  'pages.settings.generalSection.languagePlaceholder':
    'Sélectionner la langue par défaut',
  'pages.settings.generalSection.site': 'Site',
  'pages.settings.generalSection.frontendUrl': 'URL du Frontend',
  'pages.settings.generalSection.frontendUrlPlaceholder':
    'https://console.exemple.com',
  'pages.settings.generalSection.backendUrl': 'URL du Backend',
  'pages.settings.generalSection.backendUrlExtra':
    'Laissez vide pour utiliser la même origine que le frontend.',
  'pages.settings.generalSection.backendUrlPlaceholder':
    'https://api.exemple.com',
  'pages.settings.generalSection.urlInvalid': 'Veuillez saisir une URL valide',
  'pages.settings.generalSection.webauthn': 'WebAuthn / Passkeys',
  'pages.settings.generalSection.webauthnEnabled': 'Activer WebAuthn',
  'pages.settings.generalSection.webauthnEnabledExtra':
    "Autoriser les utilisateurs à s'inscrire et se connecter avec des Passkeys.",
  'pages.settings.generalSection.webauthnUnsupported':
    'Ce navigateur ne prend pas en charge WebAuthn. La connexion par Passkey ne sera pas disponible pour les utilisateurs sur des clients non pris en charge.',
  'pages.settings.generalSection.rpName': 'Nom de la partie prenante (RP Name)',
  'pages.settings.generalSection.rpNameExtra':
    "Nom lisible affiché lors de l'invite Passkey.",
  'pages.settings.generalSection.rpNamePlaceholder': 'RustDesk Console',
  'pages.settings.generalSection.security': 'Sécurité et maintenance',
  'pages.settings.generalSection.jwtExpiryDays':
    'Expiration du jeton JWT (jours)',
  'pages.settings.generalSection.jwtExpiryDaysExtra':
    "Nombre de jours avant l'expiration des jetons utilisateurs. Doit être d'au moins 1.",
  'pages.settings.generalSection.jwtExpiryDaysRequired':
    'Veuillez saisir un entier positif',
  'pages.settings.generalSection.auditRetentionDays':
    "Rétention des journaux d'audit (jours)",
  'pages.settings.generalSection.auditRetentionDaysExtra':
    "Nombre de jours de conservation des journaux d'audit avant nettoyage automatique. Définir à 0 pour désactiver.",
  'pages.settings.generalSection.auditRetentionDaysRequired':
    'Veuillez saisir un entier non négatif',
  'pages.strategies.list': 'Liste des stratégies',
  'pages.strategies.name': 'Nom de la stratégie',
  'pages.strategies.note': 'Note',
  'pages.strategies.create': 'Créer une stratégie',
  'pages.strategies.edit': 'Modifier la stratégie',
  'pages.strategies.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cette stratégie ?',
  'pages.strategies.createSuccess': 'Stratégie créée',
  'pages.strategies.createFailed': 'Échec de la création de la stratégie',
  'pages.strategies.updateSuccess': 'Stratégie mise à jour',
  'pages.strategies.updateFailed': 'Échec de la mise à jour de la stratégie',
  'pages.strategies.deleteSuccess': 'Stratégie supprimée',
  'pages.strategies.deleteFailed': 'Échec de la suppression de la stratégie',
  'pages.strategies.enterName': 'Saisissez le nom de la stratégie',
  'pages.strategies.configOptions': 'Options de configuration',
  'pages.strategies.defaultLabel': 'Par défaut',
  'pages.strategies.defaultValue': 'Par défaut : {value}',
  'pages.strategies.resetToDefault': 'Réinitialiser par défaut',
  'pages.strategies.modifiedSummary': '{count} configuration(s) modifiée(s)',
  'pages.strategies.resetAll': 'Tout réinitialiser',
  'pages.strategies.assign': 'Attribuer',
  'pages.strategies.assignManagement': 'Gestion des attributions',
  'pages.strategies.assignDevice': 'Appareil',
  'pages.strategies.assignUser': 'Utilisateur',
  'pages.strategies.assignDeviceGroup': "Groupe d'appareils",
  'pages.strategies.assignedTargets': 'Cibles attribuées',
  'pages.strategies.noAssigned': 'Aucune cible attribuée',
  'pages.strategies.addAssignment': 'Ajouter une attribution',
  'pages.strategies.selectTarget': 'Sélectionner la cible',
  'pages.strategies.assignSuccess': 'Stratégie attribuée avec succès',
  'pages.strategies.assignFailed': "Échec de l'attribution de la stratégie",
  'pages.strategies.assignPartialFailed':
    '{success} cible(s) attribuée(s), {failed} échec(s) : {errors}',
  'pages.strategies.unassignSuccess': 'Stratégie retirée avec succès',
  'pages.strategies.unassignFailed': 'Échec du retrait de la stratégie',
  'pages.strategies.unassignConfirm': 'Retirer la stratégie de cette cible ?',
  'pages.strategies.fetchDetailFailed':
    'Échec de la récupération des détails de la stratégie',
  'pages.strategies.updatedAt': 'Mis à jour le',
  'pages.strategies.category.connection': 'Connexion & Accès',
  'pages.strategies.category.security': 'Sécurité & Authentification',
  'pages.strategies.category.display': 'Affichage & Interface',
  'pages.strategies.category.av': 'Audio/Vidéo & Codec',
  'pages.strategies.category.file': 'Fichiers & Presse-papiers',
  'pages.strategies.category.advanced': 'Avancé',
  'pages.strategies.category.floating': 'Fenêtre flottante',
  'pages.strategies.category.privacy': 'Confidentialité & Enregistrement',
  'pages.users.inviteSuccess': 'Invitation envoyée',
  'pages.users.inviteFailed': "Échec de l'envoi de l'invitation",
  'pages.users.active': 'Actif',
  'pages.users.disabled': 'Désactivé',
  'pages.users.unverified': 'Non vérifié',
  'pages.users.strategy': 'Stratégie',
  'pages.users.invite': 'Inviter un utilisateur',
  'pages.users.password': 'Mot de passe',
  'pages.users.isAdmin': 'Admin',
  'pages.users.normalUser': 'Normal',
  'pages.users.edit': "Modifier l'utilisateur",
  'pages.users.updateSuccess': 'Utilisateur mis à jour',
  'pages.users.updateFailed': "Échec de la mise à jour de l'utilisateur",
  'pages.users.security': 'Sécurité',
  'pages.users.securitySettings': 'Paramètres de sécurité',
  'pages.users.securityUpdateSuccess': 'Paramètres de sécurité mis à jour',
  'pages.users.securityUpdateFailed':
    'Échec de la mise à jour des paramètres de sécurité',
  'pages.users.tfaEnforce': "Imposer l'authentification à deux facteurs",
  'pages.users.emailVerification': "Exiger la vérification de l'e-mail",
  'pages.users.resetPassword': 'Réinitialiser le mot de passe',
  'pages.users.resetPasswordTooltip':
    'Laisser vide pour conserver le mot de passe actuel',
  'pages.users.confirmPassword': 'Confirmer le mot de passe',
  'pages.users.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'pages.users.passwordTooShort':
    'Le mot de passe doit contenir au moins 6 caractères',
  'pages.users.forceLogout': 'Déconnexion',
  'pages.users.forceLogoutSuccess': 'Déconnexion forcée réussie',
  'pages.users.forceLogoutFailed': 'Échec de la déconnexion forcée',
  'pages.users.batchEnable': 'Activer en lot',
  'pages.users.batchDisable': 'Désactiver en lot',
  'pages.users.batchForceLogout': 'Forcer la déconnexion en lot',
  'pages.users.batchEnableConfirm':
    'Êtes-vous sûr de vouloir activer les utilisateurs sélectionnés ?',
  'pages.users.batchDisableConfirm':
    'Êtes-vous sûr de vouloir désactiver les utilisateurs sélectionnés ?',
  'pages.users.batchForceLogoutConfirm':
    'Êtes-vous sûr de vouloir forcer la déconnexion des utilisateurs sélectionnés ?',
  'pages.users.batchEnableSuccess':
    '{count} utilisateur(s) activé(s) avec succès',
  'pages.users.batchEnableFailed': "Échec de l'activation des utilisateurs",
  'pages.users.batchEnablePartialFailed':
    '{success} utilisateur(s) activé(s) avec succès, {failed} échec(s)',
  'pages.users.batchDisableSuccess':
    '{count} utilisateur(s) désactivé(s) avec succès',
  'pages.users.batchDisableFailed':
    'Échec de la désactivation des utilisateurs',
  'pages.users.batchDisablePartialFailed':
    '{success} utilisateur(s) désactivé(s) avec succès, {failed} échec(s)',
  'pages.users.batchForceLogoutSuccess': 'Déconnexion forcée en lot réussie',
  'pages.users.batchForceLogoutFailed':
    'Échec de la déconnexion forcée des utilisateurs',
  'pages.dashboard.totalUsers': 'Utilisateurs',
  'pages.dashboard.adminUsers': 'Admin',
  'pages.dashboard.normalUsers': 'Normal',
  'pages.dashboard.totalDevices': 'Appareils',
  'pages.dashboard.onlineDevices': 'En ligne',
  'pages.dashboard.offlineDevices': 'Hors ligne',
  'pages.dashboard.todayConnections': 'Connexions',
  'pages.dashboard.successCount': 'Succès',
  'pages.dashboard.failureCount': 'Échec',
  'pages.dashboard.todayTransfers': 'Transferts',
  'pages.dashboard.uploadCount': 'Envoi',
  'pages.dashboard.downloadCount': 'Téléchargement',
  'pages.dashboard.systemStatus': 'Statut du système',
  'pages.dashboard.uptime': 'Temps de fonctionnement',
  'pages.dashboard.trendData': 'Tendances',
  'pages.dashboard.alarmTrend': 'Alarmes',
  'pages.dashboard.resourceCounts': 'Ressources',
  'pages.dashboard.addressBooks': "Carnets d'adresses",
  'pages.dashboard.groups': 'Groupes',
  'pages.dashboard.roles': 'Rôles',
  'pages.dashboard.strategies': 'Stratégies',

  'pages.common.pleaseEnterName': 'Veuillez saisir le nom',
  'pages.common.pleaseEnterId': "Veuillez saisir l'ID",
  'pages.common.pleaseEnterTagName': "Veuillez saisir le nom de l'étiquette",
  'pages.common.pleaseEnterUsername': "Veuillez saisir le nom d'utilisateur",
  'pages.common.pleaseEnterEmail': "Veuillez saisir l'e-mail",
  'pages.common.pleaseEnterValidEmail': 'Veuillez saisir un e-mail valide',
  'pages.common.pleaseEnterPassword': 'Veuillez saisir le mot de passe',
  'pages.common.pleaseEnterRoleName': 'Veuillez saisir le nom du rôle',
  'pages.common.id': 'ID',
  'pages.dashboard.day': 'j',
  'pages.dashboard.hour': 'h',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'Processeur',
  'pages.dashboard.memory': 'Mémoire',
  'pages.dashboard.disk': 'Disque',
  'pages.dashboard.connectionTrend': 'Connexions',
  'pages.dashboard.newUsersTrend': 'Nouveaux utilisateurs',

  'pages.dashboard.7days': '7 jours',
  'pages.dashboard.30days': '30 jours',
  'pages.dashboard.90days': '90 jours',
  'pages.dashboard.noData': 'Aucune donnée',
  'pages.smtp.title': 'Configuration SMTP',
  'pages.smtp.description':
    "Configurer le serveur de messagerie SMTP pour l'envoi des e-mails de notification système",
  'pages.smtp.host': 'Adresse du serveur',
  'pages.smtp.hostPlaceholder': "Veuillez saisir l'adresse du serveur SMTP",
  'pages.smtp.port': 'Port',
  'pages.smtp.portPlaceholder': 'Veuillez saisir le numéro de port',
  'pages.smtp.secure': 'Utiliser SSL/TLS',
  'pages.smtp.secureHelp':
    'Activer la connexion sécurisée (généralement le port 465 utilise SSL, le port 587 utilise TLS)',
  'pages.smtp.user': "Nom d'utilisateur",
  'pages.smtp.userPlaceholder':
    "Veuillez saisir le nom d'utilisateur d'authentification SMTP",
  'pages.smtp.password': 'Mot de passe',
  'pages.smtp.passwordPlaceholder':
    "Veuillez saisir le mot de passe d'authentification SMTP",
  'pages.smtp.from': "E-mail de l'expéditeur",
  'pages.smtp.fromPlaceholder':
    "Veuillez saisir l'adresse e-mail de l'expéditeur",
  'pages.smtp.enabled': 'Activer la configuration',
  'pages.smtp.enabledHelp':
    "Lorsqu'elle est activée, cette configuration sera utilisée pour envoyer les e-mails système",
  'pages.smtp.testConnection': 'Tester la connexion',
  'pages.smtp.testSuccess': 'Test de connexion SMTP réussi',
  'pages.smtp.testFailed': 'Échec du test de connexion SMTP',
  'pages.smtp.saveSuccess': 'Configuration SMTP enregistrée avec succès',
  'pages.smtp.saveFailed': "Échec de l'enregistrement de la configuration SMTP",
  'pages.smtp.createdAt': 'Créé le',
  'pages.smtp.updatedAt': 'Mis à jour le',
  'pages.addressBook.color': 'Couleur',
  'pages.addressBook.deviceInfo': 'nom_utilisateur@nom_appareil',
  'pages.addressBook.manageTags': 'Gérer les étiquettes',
  'pages.addressBook.newTagName': "Nouveau nom d'étiquette",
  'pages.addressBook.peerUpdateFailed': 'Échec de la mise à jour du pair',
  'pages.addressBook.peerUpdated': 'Pair mis à jour',
  'pages.addressBook.renameTag': "Renommer l'étiquette",
  'pages.addressBook.selectTags': 'Sélectionner des étiquettes',
  'pages.addressBook.tagColorUpdateFailed':
    "Échec de la mise à jour de la couleur de l'étiquette",
  'pages.addressBook.tagRenameFailed':
    "Échec du changement de nom de l'étiquette",
  'pages.addressBook.tagRenamed': 'Étiquette renommée',
  'pages.addressBook.untagged': 'Sans étiquette',
  'pages.common.cancel': 'Non',
  'pages.common.confirm': 'Oui',
  'pages.common.enterDescription': 'Saisir une description',
  'pages.common.rename': 'Renommer',
  'pages.common.save': 'Enregistrer',
  'pages.userGroups.enterName': 'Saisir le nom du groupe',
  'pages.users.admin': 'Admin',
  'pages.users.me': 'Moi',
  'pages.oidcProviders.list': 'Fournisseurs OIDC',
  'pages.oidcProviders.sort': 'Trier',
  'pages.oidcProviders.name': 'Nom du fournisseur',
  'pages.oidcProviders.type': 'Type',
  'pages.oidcProviders.issuer': "URL de l'émetteur (Issuer)",
  'pages.oidcProviders.clientId': 'ID Client',
  'pages.oidcProviders.clientSecret': 'Secret Client',
  'pages.oidcProviders.scope': 'Portée (Scope)',
  'pages.oidcProviders.authorizationEndpoint': "Point d'accès d'autorisation",
  'pages.oidcProviders.tokenEndpoint': "Point d'accès aux jetons",
  'pages.oidcProviders.userinfoEndpoint': "Point d'accès Userinfo",
  'pages.oidcProviders.jwksUri': 'URI JWKS',
  'pages.oidcProviders.enabled': 'Activé',
  'pages.oidcProviders.endpointConfig': "Configuration des points d'accès",
  'pages.oidcProviders.create': 'Créer un fournisseur',
  'pages.oidcProviders.edit': 'Modifier le fournisseur',
  'pages.oidcProviders.test': 'Tester',
  'pages.oidcProviders.testResult': 'Résultat du test de connexion',
  'pages.oidcProviders.discoveredEndpoints': "Points d'accès découverts",
  'pages.oidcProviders.enterName': 'Saisissez le nom du fournisseur',
  'pages.oidcProviders.enterIssuer': "Saisissez l'URL de l'émetteur",
  'pages.oidcProviders.enterClientId': "Saisissez l'ID Client",
  'pages.oidcProviders.enterClientSecret': 'Saisissez le secret client',
  'pages.oidcProviders.enterEndpoint': 'Découverte automatique si vide',
  'pages.oidcProviders.createSuccess': 'Fournisseur OIDC créé',
  'pages.oidcProviders.createFailed':
    'Échec de la création du fournisseur OIDC',
  'pages.oidcProviders.updateSuccess': 'Fournisseur OIDC mis à jour',
  'pages.oidcProviders.updateFailed':
    'Échec de la mise à jour du fournisseur OIDC',
  'pages.oidcProviders.deleteSuccess': 'Fournisseur OIDC supprimé',
  'pages.oidcProviders.deleteFailed':
    'Échec de la suppression du fournisseur OIDC',
  'pages.oidcProviders.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer ce fournisseur ?',
  'pages.oidcProviders.enableSuccess': 'Fournisseur OIDC activé',
  'pages.oidcProviders.enableFailed':
    "Échec de l'activation du fournisseur OIDC",
  'pages.oidcProviders.disableSuccess': 'Fournisseur OIDC désactivé',
  'pages.oidcProviders.disableFailed':
    'Échec de la désactivation du fournisseur OIDC',
  'pages.oidcProviders.enableConfirm':
    'Êtes-vous sûr de vouloir activer ce fournisseur ?',
  'pages.oidcProviders.disableConfirm':
    'Êtes-vous sûr de vouloir désactiver ce fournisseur ?',
  'pages.oidcProviders.testFailed': 'Échec du test de connexion OIDC',
  'pages.oidcProviders.fetchDetailFailed':
    'Échec de la récupération des détails du fournisseur',
  'pages.oidcProviders.sortFailed':
    "Échec de la mise à jour de l'ordre des fournisseurs",
  'pages.oidcProviders.preset': 'Modèle de fournisseur',
  'pages.oidcProviders.presetPlaceholder':
    'Sélectionnez un fournisseur intégré ou personnalisé',
  'pages.oidcProviders.custom': 'Personnalisé',
  'pages.oidcProviders.icon': 'Icône (SVG)',
  'pages.oidcProviders.uploadSvg': 'Télécharger SVG',
  'pages.oidcProviders.clearIcon': 'Effacer',
  'pages.oidcProviders.svgTooLarge': 'Fichier SVG trop volumineux (max 100Ko)',
  'pages.oidcProviders.invalidSvg': 'Contenu SVG invalide',
  'pages.user.center.tab.basic': 'Informations de base',
  'pages.user.center.tab.security': 'Sécurité',
  'pages.user.center.basicInfo.displayName': "Nom d'affichage",
  'pages.user.center.basicInfo.displayNamePlaceholder':
    "Saisissez un nom d'affichage",
  'pages.user.center.basicInfo.name': "Nom d'utilisateur",
  'pages.user.center.basicInfo.email': 'E-mail',
  'pages.user.center.basicInfo.note': 'Note',
  'pages.user.center.basicInfo.updateSuccess': 'Profil mis à jour avec succès',
  'pages.user.center.basicInfo.updateFailed':
    'Échec de la mise à jour du profil',
  'pages.user.center.avatar.hint':
    'Prend en charge JPG, PNG, WebP, max 2 Mo, sera redimensionné en 256x256',
  'pages.user.center.avatar.upload': 'Téléverser un avatar',
  'pages.user.center.avatar.delete': "Supprimer l'avatar",
  'pages.user.center.avatar.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer votre avatar ?',
  'pages.user.center.avatar.uploadSuccess': 'Avatar téléversé avec succès',
  'pages.user.center.avatar.uploadFailed': "Échec du téléversement de l'avatar",
  'pages.user.center.avatar.deleteSuccess': 'Avatar supprimé avec succès',
  'pages.user.center.avatar.deleteFailed':
    "Échec de la suppression de l'avatar",
  'pages.user.center.avatar.fileTooLarge':
    'La taille du fichier ne peut pas dépasser 2 Mo',
  'pages.user.center.avatar.invalidFormat':
    'Seuls les formats JPG, PNG et WebP sont pris en charge',
  'pages.user.center.security.title': 'Paramètres de sécurité',
  'pages.user.center.security.2faStatus': 'Statut 2FA',
  'pages.user.center.security.enabled': 'Activé',
  'pages.user.center.security.disabled': 'Désactivé',
  'pages.user.center.security.enable2FA': 'Activer la 2FA',
  'pages.user.center.security.disable2FA': 'Désactiver la 2FA',
  'pages.user.center.security.setup2FA':
    "Configurer l'authentification à deux facteurs",
  'pages.user.center.security.setupFailed': 'Échec de la configuration 2FA',
  'pages.user.center.security.scanQRCode':
    "Scannez le code QR avec votre application d'authentification, puis saisissez le code de vérification ci-dessous.",
  'pages.user.center.security.secretKey': 'Clé secrète',
  'pages.user.center.security.verificationCode': 'Code de vérification',
  'pages.user.center.security.enterCode':
    'Veuillez saisir le code de vérification',
  'pages.user.center.security.verifyAndEnable': 'Vérifier & Activer',
  'pages.user.center.security.enableSuccess': '2FA activée avec succès',
  'pages.user.center.security.enableFailed': "Échec de l'activation de la 2FA",
  'pages.user.center.security.currentCode': 'Code de vérification actuel',
  'pages.user.center.security.confirmDisable': 'Confirmer la désactivation',
  'pages.user.center.security.disableSuccess': '2FA désactivée avec succès',
  'pages.user.center.security.disableFailed':
    'Échec de la désactivation de la 2FA',
  'pages.user.center.security.password': 'Mot de passe de connexion',
  'pages.user.center.security.passwordSet': 'Défini',
  'pages.user.center.security.passwordNotSet': 'Non défini',
  'pages.user.center.security.changePassword': 'Changer le mot de passe',
  'pages.user.center.security.currentPassword': 'Mot de passe actuel',
  'pages.user.center.security.enterCurrentPassword':
    'Veuillez saisir votre mot de passe actuel',
  'pages.user.center.security.newPassword': 'Nouveau mot de passe',
  'pages.user.center.security.enterNewPassword':
    'Veuillez saisir un nouveau mot de passe (6 caractères min.)',
  'pages.user.center.security.confirmNewPassword':
    'Confirmer le nouveau mot de passe',
  'pages.user.center.security.confirmNewPasswordPlaceholder':
    'Veuillez ressaisir le nouveau mot de passe',
  'pages.user.center.security.passwordMinLength':
    'Le mot de passe doit contenir au moins 6 caractères',
  'pages.user.center.security.passwordMismatch':
    'Les deux mots de passe ne correspondent pas',
  'pages.user.center.security.changePasswordSuccess':
    'Mot de passe modifié avec succès',
  'pages.user.center.security.changePasswordFailed':
    'Échec de la modification du mot de passe',
  'pages.user.center.security.thirdPartyUser':
    'Les utilisateurs connectés via un tiers ne peuvent pas modifier leur mot de passe',
  'pages.user.center.security.noPasswordUser':
    'Aucun mot de passe défini pour ce compte',
  'pages.user.center.security.passkey.title': 'Gestion des Passkeys',
  'pages.user.center.security.passkey.register': 'Enregistrer une Passkey',
  'pages.user.center.security.passkey.registerSuccess':
    'Passkey enregistrée avec succès',
  'pages.user.center.security.passkey.registerFailed':
    "Échec de l'enregistrement de la Passkey",
  'pages.user.center.security.passkey.deleteSuccess':
    'Passkey supprimée avec succès',
  'pages.user.center.security.passkey.deleteFailed':
    'Échec de la suppression de la Passkey',
  'pages.user.center.security.passkey.deleteConfirm':
    'Êtes-vous sûr de vouloir supprimer cette Passkey ?',
  'pages.user.center.security.passkey.name': 'Nom',
  'pages.user.center.security.passkey.namePlaceholder': 'ex. Touch ID MacBook',
  'pages.user.center.security.passkey.namePasskey': 'Nommez votre Passkey',
  'pages.user.center.security.passkey.deviceType': "Type d'appareil",
  'pages.user.center.security.passkey.multiDevice': 'Multi-appareils',
  'pages.user.center.security.passkey.singleDevice': 'Appareil unique',
  'pages.user.center.security.passkey.createdAt': 'Créé le',
  'pages.user.center.security.passkey.noCredentials':
    'Aucune Passkey enregistrée',
  'pages.user.center.security.passkey.tfaStatus': '2FA par Passkey',
  'pages.user.center.security.passkey.tfaEnabled': '2FA par Passkey activée',
  'pages.user.center.security.passkey.tfaDisabled':
    '2FA par Passkey désactivée',
  'pages.user.center.security.passkey.tfaToggleFailed':
    'Échec du basculement de la 2FA par Passkey',
  'pages.user.center.security.sessions.title': 'Sessions de connexion',
  'pages.user.center.security.sessions.device': 'Appareil',
  'pages.user.center.security.sessions.type': 'Type',
  'pages.user.center.security.sessions.browser': 'Navigateur',
  'pages.user.center.security.sessions.client': 'Client',
  'pages.user.center.security.sessions.os': "Système d'exploitation",
  'pages.user.center.security.sessions.createdAt': 'Créée le',
  'pages.user.center.security.sessions.expiresAt': 'Expire le',
  'pages.user.center.security.sessions.current': 'Actuelle',
  'pages.user.center.security.sessions.revoke': 'Révoquer',
  'pages.user.center.security.sessions.revokeConfirm':
    'Êtes-vous sûr de vouloir révoquer cette session ?',
  'pages.user.center.security.sessions.revokeSuccess':
    'Session révoquée avec succès',
  'pages.user.center.security.sessions.revokeFailed':
    'Échec de la révocation de la session',
  'pages.user.center.security.sessions.cannotRevokeCurrent':
    'Impossible de révoquer la session actuelle',
  'pages.user.center.security.sessions.noSessions': 'Aucune session active',
  'pages.ldap.title': 'Configuration LDAP',
  'pages.ldap.description':
    "Configurer l'authentification LDAP / Active Directory. Les utilisateurs seront automatiquement authentifiés via LDAP lorsqu'elle est activée.",
  'pages.ldap.urls': 'URL des serveurs',
  'pages.ldap.urlsRequired': 'Veuillez saisir au moins une URL de serveur LDAP',
  'pages.ldap.urlPlaceholder': 'ex. ldaps://ad.exemple.com:636',
  'pages.ldap.addUrl': 'Ajouter une URL de serveur',
  'pages.ldap.bindDN': 'DN de liaison (Bind DN)',
  'pages.ldap.bindDNRequired':
    'Veuillez saisir le Bind DN du compte de service',
  'pages.ldap.bindDNPlaceholder':
    'ex. CN=svc-ldap,OU=ServiceAccounts,DC=exemple,DC=com',
  'pages.ldap.bindCredentials': 'Mot de passe de liaison',
  'pages.ldap.bindCredentialsRequired':
    'Veuillez saisir le mot de passe du compte de service',
  'pages.ldap.bindCredentialsPlaceholder':
    'Veuillez saisir le mot de passe du compte de service',
  'pages.ldap.searchBase': 'DN de base de recherche',
  'pages.ldap.searchBaseRequired': 'Veuillez saisir le DN de base de recherche',
  'pages.ldap.searchBasePlaceholder': 'ex. DC=exemple,DC=com',
  'pages.ldap.searchFilter': 'Filtre de recherche',
  'pages.ldap.searchFilterRequired': 'Veuillez saisir le filtre de recherche',
  'pages.ldap.searchFilterHelp':
    "Utilisez {{username}} comme espace réservé pour le nom d'utilisateur. AD : (sAMAccountName={{username}}), OpenLDAP : (uid={{username}})",
  'pages.ldap.searchFilterPlaceholder': 'ex. (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Attributs de recherche',
  'pages.ldap.searchAttributePlaceholder':
    'ex. dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Ajouter un attribut',
  'pages.ldap.groupSearchBase': 'DN de base pour la recherche de groupes',
  'pages.ldap.groupSearchBasePlaceholder': 'ex. OU=Groups,DC=exemple,DC=com',
  'pages.ldap.groupSearchFilter': 'Filtre de recherche de groupes',
  'pages.ldap.groupSearchFilterHelp':
    "Utilisez {{dn}} comme espace réservé pour le DN d'utilisateur. ex. (member={{dn}})",
  'pages.ldap.groupSearchFilterPlaceholder': 'ex. (member={{dn}})',
  'pages.ldap.adminGroups': 'Groupes administrateurs',
  'pages.ldap.adminGroupsHelp':
    'Les utilisateurs appartenant à ces groupes LDAP seront définis comme administrateurs (insensible à la casse)',
  'pages.ldap.adminGroupPlaceholder':
    'ex. CN=Admins,OU=Groups,DC=exemple,DC=com',
  'pages.ldap.addAdminGroup': 'Ajouter un groupe administrateur',
  'pages.ldap.tlsOptions': 'Options TLS',
  'pages.ldap.tlsCa': 'Certificat CA (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Certificat client (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Clé privée client (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'Nom de serveur SNI',
  'pages.ldap.tlsServernamePlaceholder':
    'Indication du nom de serveur pour TLS',
  'pages.ldap.enabled': "Activer l'authentification LDAP",
  'pages.ldap.enabledHelp':
    "Lorsqu'elle est activée, les utilisateurs seront authentifiés auprès du serveur LDAP. Les utilisateurs existants liés à LDAP utiliseront toujours l'authentification LDAP quel que soit ce paramètre.",
  'pages.ldap.testConnection': 'Tester la connexion',
  'pages.ldap.testSuccess': 'Test de connexion LDAP réussi',
  'pages.ldap.testFailed': 'Échec du test de connexion LDAP',
  'pages.ldap.saveSuccess': 'Configuration LDAP enregistrée avec succès',
  'pages.ldap.saveFailed': "Échec de l'enregistrement de la configuration LDAP",
  'pages.ldap.createdAt': 'Créé le',
  'pages.ldap.updatedAt': 'Mis à jour le',
  'pages.nexus.repoRequired': 'Interaction avec le dépôt requise',
  'pages.nexus.repoRequiredDesc':
    "Vous devez ajouter une Étoile (Star), Forker ou Suivre (Watch) le dépôt databk/rustdesk-console sur GitHub avant de générer des clients personnalisés. Le rafraîchissement du cache peut prendre jusqu'à 5 minutes.",
  'pages.nexus.goToRepo': 'Aller au dépôt GitHub',
  'pages.nexus.buildList': 'Historique de génération',
  'pages.nexus.createBuild': 'Créer un nouveau client',
  'pages.nexus.createBuildTitle': 'Créer un client personnalisé',
  'pages.nexus.customConfig': 'Configuration personnalisée',
  'pages.nexus.serverConfig': 'Configuration du serveur',
  'pages.nexus.password': 'Mot de passe',
  'pages.nexus.passwordPlaceholder': 'Entrer le mot de passe',
  'pages.nexus.salt': 'Sel (Salt)',
  'pages.nexus.saltPlaceholder': 'Entrer le sel',
  'pages.nexus.connType': 'Type de connexion',
  'pages.nexus.disableInstallation': "Désactiver l'installation",
  'pages.nexus.disableSettings': 'Désactiver les paramètres',
  'pages.nexus.disableAccount': 'Désactiver le compte',
  'pages.nexus.disableAb': "Désactiver le carnet d'adresses (AB)",
  'pages.nexus.disableTcpListen': "Désactiver l'écoute TCP",
  'pages.nexus.rendezvousServer': "Serveur d'ID",
  'pages.nexus.relayServer': 'Serveur relais',
  'pages.nexus.key': 'Clé',
  'pages.nexus.apiServer': 'Serveur API',
  'pages.nexus.overrideSettings': 'Remplacer les paramètres',
  'pages.nexus.defaultSettings': 'Paramètres par défaut',
  'pages.nexus.deleteBuildConfirm':
    'Êtes-vous sûr de vouloir supprimer cet enregistrement de génération ?',
  'pages.nexus.deleteSuccess': 'Enregistrement de génération supprimé',
  'pages.nexus.deleteFailed':
    "Échec de la suppression de l'enregistrement de génération",
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.os': "Système d'exploitation",
  'pages.nexus.arch': 'Architecture',
  'pages.nexus.appName': "Nom de l'application",
  'pages.nexus.appNamePlaceholder': 'ex. mon-rustdesk',
  'pages.nexus.appNameHint': 'Seules les lettres anglaises sont autorisées',
  'pages.nexus.bindSuccess': 'Compte GitHub lié avec succès',
  'pages.nexus.bindFailed': 'Échec de la liaison du compte GitHub',
  'pages.nexus.createLoginFailed':
    'Échec de la création de la session de connexion',
  'pages.nexus.unbindConfirm': 'Délier le compte GitHub',
  'pages.nexus.unbindConfirmContent':
    'Êtes-vous sûr de vouloir délier votre compte GitHub ? Vous devrez le relier pour générer des clients personnalisés.',
  'pages.nexus.unbindSuccess': 'Compte GitHub délié',
  'pages.nexus.unbindFailed': 'Échec de la dissociation du compte GitHub',
  'pages.nexus.tokenExpired': 'Jeton GitHub expiré',
  'pages.nexus.tokenExpiredDesc':
    'Votre jeton GitHub pour {username} a expiré. Veuillez relier votre compte.',
  'pages.nexus.rebind': 'Relier le compte GitHub',
  'pages.nexus.bindTitle': 'Lier le compte GitHub',
  'pages.nexus.bindDesc':
    'Vous devez lier votre compte GitHub pour générer des clients personnalisés. Cliquez sur le bouton ci-dessous pour autoriser via GitHub.',
  'pages.nexus.bindGithub': 'Autoriser avec GitHub',
  'pages.nexus.unbind': 'Délier',
  'pages.nexus.repoInteractionRequired':
    "Veuillez d'abord ajouter une Étoile (Star), Forker ou Suivre (Watch) le dépôt databk/rustdesk-console sur GitHub. Le rafraîchissement du cache peut prendre jusqu'à 5 minutes.",
  'pages.nexus.buildAlreadyRunning': 'Une génération est déjà en cours',
  'pages.nexus.generateFailed': "Échec de l'envoi de la demande de génération",
  'pages.nexus.retryBuild': 'Réessayer',
  'pages.nexus.retryBuildFailed': 'Échec de la tentative de régénération',
  'pages.nexus.downloadFailed':
    'Échec du téléchargement du client personnalisé',
  'pages.nexus.buildAgain': 'Générer à nouveau',
  'pages.nexus.status': 'Statut',
  'pages.nexus.statusPending': 'Génération en attente',
  'pages.nexus.statusBuilding': 'Génération en cours',
  'pages.nexus.statusCompleted': 'Génération terminée',
  'pages.nexus.statusFailed': 'Génération échouée',
  'pages.nexus.statusCancelled': 'Génération annulée',
  'pages.nexus.bindWhyLogin':
    "L'authentification GitHub nous aide à vérifier que vous êtes un véritable utilisateur, évitant ainsi l'utilisation abusive et automatisée des ressources de génération. Nous demandons uniquement l'accès à vos données publiques — aucun accès à vos dépôts ou données personnelles n'est requis.",
  'pages.nexus.repoWhyInteract':
    "Je suis un élève du secondaire qui développe ce projet pendant son temps libre. Votre Étoile (Star), Fork ou Suivi (Watch) compte beaucoup pour moi — cela me motive au quotidien et m'aide pour mes dossiers universitaires. C'est la seule chose que je demande en retour. Merci beaucoup pour votre soutien !",
  'pages.addressBook.accessReadOnlyTitle':
    '{name} - Paramètres de partage en lecture seule',
  'pages.addressBook.viewShareSettings': 'Paramètres de partage',
  'pages.addressBook.searchIdPlaceholder': 'Rechercher par ID',
  'pages.addressBook.searchNamePlaceholder': 'Rechercher par nom',
  'pages.addressBook.searchNotePlaceholder': 'Rechercher par note',
  'pages.audits.connectionId': 'ID de connexion',
  'pages.audits.currentConnections': 'Connexions actuelles',
  'pages.audits.operator': 'Opérateur',
  'pages.audits.reason': 'Raison',
  'pages.audits.result': 'Résultat',
  'pages.audits.targetId': 'ID cible',
  'pages.audits.targetType': 'Type de cible',
  'pages.audits.unknownUser': 'Utilisateur inconnu',
  'pages.audits.result.allowed': 'Autorisé',
  'pages.audits.result.denied': 'Refusé',
  'pages.audits.target': 'Cible',
  'pages.audits.beforeState': 'État antérieur',
  'pages.audits.afterState': 'État postérieur',
  'pages.audits.searchOperatorPlaceholder': 'Rechercher par opérateur',
  'pages.audits.searchActionPlaceholder': 'Rechercher par action',
  'pages.audits.searchTargetTypePlaceholder': 'Rechercher par type de cible',
  'pages.common.back': 'Retour',
  'pages.common.close': 'Fermer',
  'pages.login.permissionsLoadFailed':
    "Les autorisations n'ont pas pu être chargées. Ouverture du carnet d'adresses personnel ; rafraîchir pour réessayer.",
  'pages.login.permissionsRetry': 'Réessayer',
  'pages.request.accessDenied':
    "Vous n'avez pas la permission d'effectuer cette action",
  'pages.request.error': 'La demande a échoué. Veuillez réessayer.',
  'pages.request.loginExpired': 'Session expirée, veuillez vous reconnecter',
  'pages.request.noResponse': "Le serveur n'a pas répondu. Veuillez réessayer.",
  'pages.request.responseStatus': 'Demande échouée (HTTP {status})',
  'pages.roles.basicFunction': 'Fonctionnalité de base',
  'pages.roles.detailLoadFailed': 'Échec du chargement des détails du rôle',
  'pages.roles.disableProtectionAffected':
    '{count} membre(s) deviendront gérables par les administrateurs délégués.',
  'pages.roles.disableProtectionConfirm':
    'Désactiver la protection pour ce rôle ?',
  'pages.roles.ownerOnly': 'Super administrateur uniquement',
  'pages.roles.permission.address_books.edit':
    "Modifier les carnets d'adresses partagés",
  'pages.roles.permission.address_books.share':
    "Créer et gérer les carnets d'adresses partagés",
  'pages.roles.permission.address_books.view':
    "Voir les paramètres des carnets d'adresses partagés",
  'pages.roles.permission.audit.view': "Voir les journaux d'audit",
  'pages.roles.permission.devices.delete': 'Supprimer des appareils',
  'pages.roles.permission.devices.disconnect': 'Déconnecter des appareils',
  'pages.roles.permission.devices.edit': 'Modifier les détails des appareils',
  'pages.roles.permission.devices.status': 'Changer le statut des appareils',
  'pages.roles.permission.devices.view': 'Voir les appareils',
  'pages.roles.permission.roles.assign': 'Attribuer des rôles',
  'pages.roles.permission.roles.create': 'Créer des rôles',
  'pages.roles.permission.roles.delete': 'Supprimer des rôles',
  'pages.roles.permission.roles.edit': 'Modifier des rôles',
  'pages.roles.permission.roles.view': 'Voir les rôles',
  'pages.roles.permission.strategies.assign': 'Attribuer des stratégies',
  'pages.roles.permission.strategies.create': 'Créer des stratégies',
  'pages.roles.permission.strategies.delete': 'Supprimer des stratégies',
  'pages.roles.permission.strategies.edit': 'Modifier des stratégies',
  'pages.roles.permission.strategies.view': 'Voir les stratégies',
  'pages.roles.permission.user_groups.create':
    "Créer des groupes d'utilisateurs",
  'pages.roles.permission.user_groups.delete':
    "Supprimer des groupes d'utilisateurs",
  'pages.roles.permission.user_groups.edit':
    "Modifier des groupes d'utilisateurs",
  'pages.roles.permission.user_groups.membership':
    "Gérer l'appartenance aux groupes d'utilisateurs",
  'pages.roles.permission.user_groups.view': "Voir les groupes d'utilisateurs",
  'pages.roles.permission.users.create': 'Créer des utilisateurs',
  'pages.roles.permission.users.delete': 'Supprimer des utilisateurs',
  'pages.roles.permission.users.edit': 'Modifier des utilisateurs',
  'pages.roles.permission.users.force_logout':
    "Forcer la déconnexion d'un utilisateur",
  'pages.roles.permission.users.security': 'Gérer la sécurité des utilisateurs',
  'pages.roles.permission.users.status': 'Changer le statut des utilisateurs',
  'pages.roles.permission.users.view': 'Voir les utilisateurs',
  'pages.roles.permissionPresets': "Préréglages d'autorisations",
  'pages.roles.permissionScopeInfo':
    "Les actions sur les appareils peuvent être attribuées globalement ou à des groupes d'appareils sélectionnés lorsqu'un utilisateur reçoit ce rôle.",
  'pages.roles.permissionsLoadFailed':
    'Échec du chargement du catalogue des autorisations',
  'pages.roles.personalAddressBook': "Carnet d'adresses personnel",
  'pages.roles.preset.custom': 'Personnalisé',
  'pages.roles.preset.deviceOperator': "Opérateur d'appareil",
  'pages.roles.preset.deviceStrategyAssigner':
    "Attribueur de stratégie d'appareil",
  'pages.roles.preset.readOnly': 'Lecture seule globale',
  'pages.roles.preset.sharedAddressBookAdministrator':
    "Administrateur de carnets d'adresses partagés",
  'pages.roles.preset.strategyMaintainer': 'Gestionnaire de stratégies',
  'pages.roles.preset.systemAdministrator': 'Administrateur système',
  'pages.roles.preset.userAdministrator': "Administrateur d'utilisateurs",
  'pages.roles.protectedAccount': 'Comptes protégés',
  'pages.roles.protectedAccountInfo':
    'Seul le super administrateur peut gérer les comptes protégés.',
  'pages.roles.resource.address_books': "Carnets d'adresses",
  'pages.roles.resource.audit': 'Audit',
  'pages.roles.resource.devices': 'Appareils',
  'pages.roles.resource.other': 'Autre',
  'pages.roles.resource.roles': 'Rôles',
  'pages.roles.resource.strategies': 'Stratégies',
  'pages.roles.resource.system': 'Capacités système',
  'pages.roles.resource.user_groups': "Groupes d'utilisateurs",
  'pages.roles.resource.servers': 'Serveurs',
  'pages.roles.permission.servers.view': 'Afficher les serveurs',
  'pages.roles.permission.servers.control':
    'Contrôler les services des serveurs',
  'pages.roles.permission.servers.config': 'Configurer les serveurs',
  'pages.roles.permission.servers.disconnect':
    'Déconnecter les sessions relais',
  'pages.roles.permission.servers.ban':
    'Gérer les règles de blocage des serveurs',
  'pages.roles.resource.users': 'Utilisateurs',
  'pages.roles.superAdminInfo':
    "L'accès super administrateur est protégé séparément et ne peut être accordé via un rôle.",
  'pages.roles.systemIdentity.builtIn': 'Intégré',
  'pages.roles.systemIdentity.ordinary': 'Utilisateur ordinaire',
  'pages.roles.systemIdentity.ordinarySummary':
    "Fonctionnalité de base du carnet d'adresses personnel uniquement.",
  'pages.roles.systemIdentity.superAdmin': 'Super administrateur',
  'pages.roles.systemIdentity.superAdminSummary':
    'Autorité effective complète pour le propriétaire unique du système.',
  'pages.roles.systemIdentity.systemCapabilities':
    "Définition des rôles, paramètres système, structure des groupes d'appareils et administration des identités",
  'pages.roles.unknownPermission': 'Autorisation inconnue',
  'pages.roles.unknownResource': 'Ressource inconnue',
  'pages.roles.view': 'Voir le rôle',
  'pages.roles.searchNamePlaceholder': 'Rechercher par nom de rôle',
  'pages.roles.searchNotePlaceholder': 'Rechercher par note',
  'pages.strategies.loadAssignedFailed':
    'Échec du chargement des cibles attribuées',
  'pages.strategies.loadTargetsFailed': 'Échec du chargement des cibles',
  'pages.strategies.option.access-mode.label': "Mode d'accès",
  'pages.strategies.option.access-mode.value.custom': 'Personnalisé',
  'pages.strategies.option.access-mode.value.full': 'Accès complet',
  'pages.strategies.option.access-mode.value.view': 'Vue uniquement',
  'pages.strategies.option.allow-always-software-render.label':
    'Toujours utiliser le rendu logiciel',
  'pages.strategies.option.allow-ask-for-note.label':
    'Demander une note de connexion',
  'pages.strategies.option.allow-auto-disconnect.label':
    'Autoriser la déconnexion automatique',
  'pages.strategies.option.allow-auto-record-incoming.label':
    "Autoriser l'enregistrement automatique des sessions entrantes",
  'pages.strategies.option.allow-auto-record-outgoing.label':
    "Autoriser l'enregistrement automatique des sessions sortantes",
  'pages.strategies.option.allow-auto-update.label':
    'Autoriser les mises à jour automatiques',
  'pages.strategies.option.allow-d3d-render.label': 'Autoriser le rendu D3D',
  'pages.strategies.option.allow-insecure-tls-fallback.label':
    'Autoriser le repli TLS non sécurisé',
  'pages.strategies.option.allow-linux-headless.label':
    'Autoriser le mode Linux headless',
  'pages.strategies.option.allow-numeric-one-time-password.label':
    'Autoriser le mot de passe à usage unique numérique',
  'pages.strategies.option.allow-only-conn-window-open.label':
    "N'autoriser que la fenêtre de connexion ouverte",
  'pages.strategies.option.allow-remote-cm-modification.label':
    'Autoriser la modification du client distant',
  'pages.strategies.option.allow-remote-config-modification.label':
    'Autoriser la modification de la configuration distante',
  'pages.strategies.option.allow-remove-wallpaper.label':
    "Autoriser la suppression du fond d'écran",
  'pages.strategies.option.allow-websocket.label': 'Autoriser WebSocket',
  'pages.strategies.option.approve-mode.label': "Mode d'approbation",
  'pages.strategies.option.approve-mode.value.click': 'Clic',
  'pages.strategies.option.approve-mode.value.password': 'Mot de passe',
  'pages.strategies.option.approve-mode.value.password-click':
    'Mot de passe et clic',
  'pages.strategies.option.auto-disconnect-timeout.description':
    "Délai d'attente en minutes",
  'pages.strategies.option.auto-disconnect-timeout.label':
    'Délai de déconnexion automatique',
  'pages.strategies.option.collapse-toolbar.label': "Réduire la barre d'outils",
  'pages.strategies.option.custom-fps.label': 'FPS personnalisé',
  'pages.strategies.option.custom-image-quality.label':
    "Qualité d'image personnalisée",
  'pages.strategies.option.direct-server.label': 'Serveur direct',
  'pages.strategies.option.disable-audio.label': "Désactiver l'audio",
  'pages.strategies.option.disable-clipboard.label':
    'Désactiver le presse-papiers',
  'pages.strategies.option.disable-discovery-panel.label':
    'Désactiver le panneau de découverte',
  'pages.strategies.option.disable-floating-window.label':
    'Désactiver la fenêtre flottante',
  'pages.strategies.option.disable-group-panel.label':
    'Désactiver le panneau de groupe',
  'pages.strategies.option.disable-udp.label': 'Désactiver UDP',
  'pages.strategies.option.displays-as-individual-windows.label':
    'Affichages en fenêtres individuelles',
  'pages.strategies.option.edge-scroll-edge-thickness.label':
    'Épaisseur du défilement de bord',
  'pages.strategies.option.enable-abr.label':
    'Activer le débit binaire adaptatif',
  'pages.strategies.option.enable-android-software-encoding-half-scale.label':
    'Encodage logiciel Android à demi-échelle',
  'pages.strategies.option.enable-audio.label': "Activer l'audio",
  'pages.strategies.option.enable-block-input.label': 'Bloquer la saisie',
  'pages.strategies.option.enable-camera.label': 'Activer la caméra',
  'pages.strategies.option.enable-clipboard.label': 'Activer le presse-papiers',
  'pages.strategies.option.enable-confirm-closing-tabs.label':
    'Confirmer la fermeture des onglets',
  'pages.strategies.option.enable-directx-capture.label':
    'Activer la capture DirectX',
  'pages.strategies.option.enable-file-copy-paste.label':
    'Activer le copier-coller de fichiers',
  'pages.strategies.option.enable-file-transfer.label':
    'Activer le transfert de fichiers',
  'pages.strategies.option.enable-hwcodec.label': 'Activer le codec matériel',
  'pages.strategies.option.enable-ipv6-punch.description':
    'Auto-hébergé : N, autres : O',
  'pages.strategies.option.enable-ipv6-punch.label':
    'Activer le perçage de trou IPv6',
  'pages.strategies.option.enable-keyboard.label':
    'Activer le clavier et la souris',
  'pages.strategies.option.enable-lan-discovery.label':
    'Activer la découverte LAN',
  'pages.strategies.option.enable-open-new-connections-in-tabs.label':
    'Ouvrir les nouvelles connexions dans des onglets',
  'pages.strategies.option.enable-record-session.label':
    "Activer l'enregistrement de session",
  'pages.strategies.option.enable-remote-printer.label':
    "Activer l'imprimante distante",
  'pages.strategies.option.enable-remote-restart.label':
    'Activer le redémarrage distant',
  'pages.strategies.option.enable-terminal.label': 'Activer le terminal',
  'pages.strategies.option.enable-trusted-devices.label':
    'Activer les appareils de confiance',
  'pages.strategies.option.enable-tunnel.label': 'Activer le tunnel',
  'pages.strategies.option.enable-udp-punch.label':
    'Activer le perçage de trou UDP',
  'pages.strategies.option.filter-ab-by-intersection.label':
    "Filtrer le carnet d'adresses par intersection",
  'pages.strategies.option.floating-window-size.label':
    'Taille de la fenêtre flottante',
  'pages.strategies.option.floating-window-transparency.label':
    'Transparence de la fenêtre flottante',
  'pages.strategies.option.floating-window-untouchable.label':
    'Fenêtre flottante non tactile',
  'pages.strategies.option.follow-remote-cursor.label':
    'Suivre le curseur distant',
  'pages.strategies.option.follow-remote-window.label':
    'Suivre la fenêtre distante',
  'pages.strategies.option.i444.label': 'Format de couleur I444',
  'pages.strategies.option.image-quality.label': "Qualité d'image",
  'pages.strategies.option.image-quality.value.balanced': 'Équilibrée',
  'pages.strategies.option.image-quality.value.best': 'Meilleure',
  'pages.strategies.option.image-quality.value.custom': 'Personnalisée',
  'pages.strategies.option.image-quality.value.low': 'Basse',
  'pages.strategies.option.keep-awake-during-incoming-sessions.label':
    'Maintenir éveillé pendant les sessions entrantes',
  'pages.strategies.option.keep-awake-during-outgoing-sessions.label':
    'Maintenir éveillé pendant les sessions sortantes',
  'pages.strategies.option.keep-screen-on.label': "Maintenir l'écran allumé",
  'pages.strategies.option.keep-screen-on.value.during-controlled':
    'Pendant la session contrôlée',
  'pages.strategies.option.keep-screen-on.value.never': 'Jamais',
  'pages.strategies.option.keep-screen-on.value.service-on': 'Service actif',
  'pages.strategies.option.lang.description': 'Code de langue',
  'pages.strategies.option.lang.label': 'Langue',
  'pages.strategies.option.lock-after-session-end.label':
    'Verrouiller après la fin de la session',
  'pages.strategies.option.peer-card-ui-type.label':
    "Type d'UI de la carte de pair",
  'pages.strategies.option.peer-card-ui-type.value.0': 'Style de carte 0',
  'pages.strategies.option.peer-card-ui-type.value.1': 'Style de carte 1',
  'pages.strategies.option.peer-card-ui-type.value.2': 'Style de carte 2',
  'pages.strategies.option.peer-sorting.label': 'Tri des pairs',
  'pages.strategies.option.peer-sorting.value.remote-host': 'Hôte distant',
  'pages.strategies.option.peer-sorting.value.remote-id': 'ID distant',
  'pages.strategies.option.peer-sorting.value.username': "Nom d'utilisateur",
  'pages.strategies.option.pre-elevate-service.label': 'Pré-élever le service',
  'pages.strategies.option.privacy-mode.label': 'Mode de confidentialité',
  'pages.strategies.option.reverse-mouse-wheel.label':
    'Inverser la molette de la souris',
  'pages.strategies.option.scroll-style.label': 'Style de défilement',
  'pages.strategies.option.scroll-style.value.scrollauto': 'Auto',
  'pages.strategies.option.scroll-style.value.scrollbar': 'Barre de défilement',
  'pages.strategies.option.scroll-style.value.scrolledge': 'Défilement de bord',
  'pages.strategies.option.show-monitors-toolbar.label':
    "Afficher la barre d'outils des moniteurs",
  'pages.strategies.option.show-quality-monitor.label':
    'Afficher le moniteur de qualité',
  'pages.strategies.option.show-remote-cursor.label':
    'Afficher le curseur distant',
  'pages.strategies.option.show-virtual-joystick.label':
    'Afficher le joystick virtuel',
  'pages.strategies.option.show-virtual-mouse.label':
    'Afficher la souris virtuelle',
  'pages.strategies.option.swap-left-right-mouse.label':
    'Inverser les boutons gauche et droit de la souris',
  'pages.strategies.option.sync-ab-tags.label':
    "Synchroniser les étiquettes du carnet d'adresses",
  'pages.strategies.option.sync-ab-with-recent-sessions.label':
    "Synchroniser le carnet d'adresses avec les sessions récentes",
  'pages.strategies.option.sync-init-clipboard.label':
    'Synchroniser le presse-papiers initial',
  'pages.strategies.option.temporary-password-length.label':
    'Longueur du mot de passe temporaire',
  'pages.strategies.option.temporary-password-length.value.10': '10 chiffres',
  'pages.strategies.option.temporary-password-length.value.6': '6 chiffres',
  'pages.strategies.option.temporary-password-length.value.8': '8 chiffres',
  'pages.strategies.option.terminal-persistent.label': 'Terminal persistant',
  'pages.strategies.option.theme.label': 'Thème',
  'pages.strategies.option.theme.value.dark': 'Sombre',
  'pages.strategies.option.theme.value.light': 'Clair',
  'pages.strategies.option.theme.value.system': 'Système',
  'pages.strategies.option.touch-mode.label': 'Mode tactile',
  'pages.strategies.option.trackpad-speed.label': 'Vitesse du trackpad',
  'pages.strategies.option.use-all-my-displays-for-the-remote-session.label':
    'Utiliser tous mes affichages pour la session distante',
  'pages.strategies.option.use-texture-render.description':
    'Dépendant de la plateforme',
  'pages.strategies.option.use-texture-render.label':
    'Utiliser le rendu de texture',
  'pages.strategies.option.verification-method.label':
    'Méthode de vérification',
  'pages.strategies.option.verification-method.value.use-both-passwords':
    'Les deux mots de passe',
  'pages.strategies.option.verification-method.value.use-permanent-password':
    'Mot de passe permanent',
  'pages.strategies.option.verification-method.value.use-temporary-password':
    'Mot de passe temporaire',
  'pages.strategies.option.view-only.label': 'Vue uniquement',
  'pages.strategies.option.view-style.label': "Style d'affichage",
  'pages.strategies.option.view-style.value.adaptive': 'Adaptatif',
  'pages.strategies.option.view-style.value.original': 'Original',
  'pages.strategies.option.whitelist.description':
    "Liste d'IP séparées par des virgules",
  'pages.strategies.option.whitelist.label': "Liste blanche d'IP",
  'pages.strategies.option.zoom-cursor.label': 'Zoom du curseur',
  'pages.strategies.values.no': 'Non',
  'pages.strategies.values.yes': 'Oui',
  'pages.strategies.view': 'Voir la stratégie',
  'pages.strategies.searchNamePlaceholder': 'Rechercher par nom de stratégie',
  'pages.userGroups.addSelected': 'Ajouter les utilisateurs sélectionnés',
  'pages.userGroups.addUsers': 'Ajouter des utilisateurs',
  'pages.userGroups.currentMembers': 'Membres actuels',
  'pages.userGroups.members': 'Membres',
  'pages.userGroups.membersTitle': 'Membres de {name}',
  'pages.userGroups.moveSelected': 'Déplacer la sélection',
  'pages.userGroups.searchNamePlaceholder': 'Rechercher par nom',
  'pages.users.addRole': 'Ajouter un rôle',
  'pages.users.deviceGroupScope': "Groupes d'appareils sélectionnés",
  'pages.users.deviceGroupScopeRequired':
    "Sélectionnez au moins un groupe d'appareils pour une attribution de groupe d'appareils",
  'pages.users.duplicateRole':
    "Un rôle ne peut être attribué qu'une seule fois",
  'pages.users.effectiveScope': 'Portée effective',
  'pages.users.globalScope': 'Global',
  'pages.users.protectedAccount': 'Compte protégé',
  'pages.users.protectedAccountInfo':
    'Les comptes protégés ne peuvent être gérés que par le super administrateur.',
  'pages.users.systemOwnerStatusBlocked':
    'Le propriétaire du système ne peut pas être activé ou désactivé.',
  'pages.users.systemOwnerMutationBlocked':
    'Le propriétaire du système ne peut pas être désactivé ni supprimé.',
  'pages.users.removeRole': 'Retirer le rôle',
  'pages.users.roleAssignmentTitle': 'Rôle {number}',
  'pages.users.roleEligibility.assign_not_allowed':
    'Vous ne pouvez pas attribuer ce rôle',
  'pages.users.roleEligibility.missing_caller_scope':
    "Votre portée d'autorisation est insuffisante",
  'pages.users.roleEligibility.missing_permission':
    'Il vous manque une autorisation requise par ce rôle',
  'pages.users.roleEligibility.protected_role':
    'Les rôles protégés ne peuvent être attribués ou retirés que par le super administrateur',
  'pages.users.roleEligibility.protected_target': 'Le compte cible est protégé',
  'pages.users.roleEligibility.remove_not_allowed':
    'Vous ne pouvez pas retirer ce rôle',
  'pages.users.roleEligibility.role_grants_roles_assign':
    "Les rôles qui accordent l'attribution de rôles ne peuvent être gérés que par le super administrateur",
  'pages.users.roleEligibility.scope_exceeds_caller':
    'La portée du rôle dépasse vos autorisations',
  'pages.users.roleEligibility.self_target':
    'Vous ne pouvez pas modifier vos propres rôles',
  'pages.users.roleEligibility.super_admin_target':
    'Les rôles ordinaires ne peuvent être attribués au super administrateur',
  'pages.users.roleRequired': 'Sélectionnez un rôle pour chaque attribution',
  'pages.users.roles': 'Rôles',
  'pages.users.rolesLoadFailed': 'Échec du chargement des rôles utilisateur',
  'pages.users.rolesSaveFailed':
    "Échec de l'enregistrement des rôles utilisateur",
  'pages.users.rolesSaved': 'Rôles utilisateur enregistrés',
  'pages.users.rolesScopeInfo':
    "Les attributions globales remplacent les attributions plus restreintes de groupes d'appareils.",
  'pages.users.rolesTitle': 'Rôles de {name}',
  'pages.users.scopeMode': 'Mode de portée du rôle',
  'pages.users.selectDeviceGroups':
    "Sélectionnez un ou plusieurs groupes d'appareils",
  'pages.users.selectRole': 'Sélectionner un rôle',
  'pages.users.superAdmin': 'Super administrateur',
  'pages.users.systemCapabilities': 'Capacités système',
  'pages.users.systemCapability.device_groups.manage':
    "Gérer la structure des groupes d'appareils",
  'pages.users.systemCapability.identity_sources.manage':
    "Gérer les sources d'identité",
  'pages.users.systemCapability.roles.create': 'Créer des définitions de rôles',
  'pages.users.systemCapability.roles.delete':
    'Supprimer des définitions de rôles',
  'pages.users.systemCapability.roles.edit':
    'Modifier des définitions de rôles',
  'pages.users.systemCapability.settings.manage':
    'Gérer les paramètres système',
  'pages.users.unsupportedDeviceGroupScope':
    "La portée de groupe d'appareils n'est disponible que pour les rôles contenant des actions sur les appareils et l'attribution de stratégies",
  'pages.users.searchNamePlaceholder': "Rechercher par nom d'utilisateur",
  'pages.users.searchEmailPlaceholder': 'Rechercher par email',
  'pages.users.searchStrategyPlaceholder': 'Rechercher par stratégie',
  'pages.users.searchUserGroupPlaceholder':
    "Rechercher par groupe d'utilisateurs",
};
